var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title-header",on:{"click":function($event){return _vm.redirectToHome()}}},[_c('h2',{staticClass:"ui header center aligned"},[_vm._v(_vm._s(_vm.headerTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }